export default __webpack_public_path__ + "static/ShamelFamily-SansMedium-66016501f960ca6a96fdc656a86b0e01.ttf";